import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ProtectedMonitorDetailsResponse } from '@um/uptime-monitoring-shared';

type SliceType = {
  initialized: boolean;
  monitor: ProtectedMonitorDetailsResponse;
};

const initialState: SliceType = {
  initialized: false,
  monitor: null,
};

export const monitorDetails = createSlice({
  name: 'monitorDetails',
  initialState,
  reducers: {
    setInitialized: (state, action: PayloadAction<boolean>) => {
      state.initialized = action.payload;
      return state;
    },
    setMonitor: (state, action: PayloadAction<ProtectedMonitorDetailsResponse>) => {
      state.monitor = action.payload;
      return state;
    },
    reset: () => {
      return initialState;
    },
  },
});

export default monitorDetails.reducer;
